import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";

import AboutUsPage from "pages/AboutUs.js";
import ContactUsPage from "pages/ContactUs.js";
import VIPSOProductPage from "pages/products/VIPSO.js";
import MindAspirantProductPage from "pages/products/MindAspirant.js";
import GroupKittyProductPage from "pages/products/GroupKitty.js";
import VIPSOPrivacyPolicy from "pages/products/vipso/PrivacyPolicy.js";
import VIPSOTerms from "pages/products/vipso/Terms.js";
import VIPSORefundPolicy from "pages/products/vipso/RefundPolicy.js";
import MindAspirantPrivacyPolicy from "pages/products/mind-aspirant/PrivacyPolicy.js";
import MindAspirantTerms from "pages/products/mind-aspirant/Terms.js";
import MindAspirantRefundPolicy from "pages/products/mind-aspirant/RefundPolicy.js";
import GroupKittyPrivacyPolicy from "pages/products/group-kitty/PrivacyPolicy.js";
import GroupKittyTerms from "pages/products/group-kitty/Terms.js";
import GroupKittyRefundPolicy from "pages/products/group-kitty/RefundPolicy.js";
import DLTSmsConsent from "pages/legal/DLTSmsConsent.js";

import SaaSProductLandingPage from "demos/SaaSProductLandingPage.js";
import ComponentRenderer from "ComponentRenderer.js";
import ThankYouPage from "ThankYouPage.js";

import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";

export default function App() {
  return (
    <Router>
      <Switch>
        <Route path="/components/:type/:subtype/:name">
          <ComponentRenderer />
        </Route>
        <Route path="/components/:type/:name">
          <ComponentRenderer />
        </Route>
        <Route path="/thank-you">
          <ThankYouPage />
        </Route>
        <Route path="/contact-us">
          <ContactUsPage />
        </Route>
        <Route path="/aboutus">
          <AboutUsPage />
        </Route>

        {/* VIPSO legal — before product route so nested paths match first */}
        <Route path="/products/vipso/privacy-policy">
          <VIPSOPrivacyPolicy />
        </Route>
        <Route path="/products/vipso/terms">
          <VIPSOTerms />
        </Route>
        <Route path="/products/vipso/refund-policy">
          <VIPSORefundPolicy />
        </Route>
        <Route path="/vipso/privacy-policy">
          <Redirect to="/products/vipso/privacy-policy" />
        </Route>

        {/* Mind Aspirant legal */}
        <Route path="/products/mind-aspirant/privacy-policy">
          <MindAspirantPrivacyPolicy />
        </Route>
        <Route path="/products/mind-aspirant/terms">
          <MindAspirantTerms />
        </Route>
        <Route path="/products/mind-aspirant/refund-policy">
          <MindAspirantRefundPolicy />
        </Route>

        {/* Group Kitty legal */}
        <Route path="/products/group-kitty/privacy-policy">
          <GroupKittyPrivacyPolicy />
        </Route>
        <Route path="/products/group-kitty/terms">
          <GroupKittyTerms />
        </Route>
        <Route path="/products/group-kitty/refund-policy">
          <GroupKittyRefundPolicy />
        </Route>

        {/* Product pages — exact so legal sub-routes are not swallowed */}
        <Route exact path="/products/vipso">
          <VIPSOProductPage />
        </Route>
        <Route exact path="/products/mind-aspirant">
          <MindAspirantProductPage />
        </Route>
        <Route exact path="/products/group-kitty">
          <GroupKittyProductPage />
        </Route>

        {/* Shared legal */}
        <Route path="/legal/dlt-sms-consent">
          <DLTSmsConsent />
        </Route>

        <Route path="/">
          <SaaSProductLandingPage />
        </Route>
      </Switch>
    </Router>
  );
}
